// 公共的接口
import qs from "qs";

export default {
  /* 框架标准公共接口： */
  changechruserpwd: (params) => $network.post('/p/cs/changechruserpwd', params),
  fuzzyquerybyak: (params, obj) => $network.post(`/p/cs/fuzzyquerybyak?hash=${+new Date()}`, params, obj ? obj : { serviceId: "r3-cp" }),
  QueryList: (params, obj) => $network.post(`/p/cs/QueryList?hash=${+new Date()}`, params, obj ? obj : { serviceId: "r3-cp" }),
  getTableQuery: (params, obj) => $network.post("/p/cs/getTableQuery", params, obj ? obj : { serviceId: "r3-cp" }),
  inputForitem: (params, obj) => $network.post(`/p/cs/inputForitem?hash=${+new Date()}`, params, obj ? obj : { serviceId: "r3-sg" }),
  skuQuery: (params, serviceId = { serviceId: "r3-cp" }) => $network.post("/api/cs/md/skuQuery", params, serviceId),
  queryChannelProduct: (params) => $network.post("/api/cs/sg/channel/product/query", params), // 查询平台店铺商品

  exportTaskCheck: (params) => $network.post("/api/cs/md/task/block", params), // 导出前校验
  getForeignKeyFiltersRows: () => $network.post("/api/cs/md/businessSystemParameters/getForeignKeyFiltersRows"), // 外键关联表格每页条数
  selSku: (params, serviceId = { serviceId: "r3-ps" }) => $network.post('/p/cs/md/sku/v1/selSku' , params , serviceId), //根据sku编码查询sku商品信息
  // 获取页面title
  getAppTitle: () => $network.get("/p/c/getAppTitle"),
  //登录
  getCaptcha: (params,serviceId = { serviceId: "r3-cp" }) => $network.get("/p/c/getCaptcha", params,serviceId),
  globalLogin: (params, serviceId = { serviceId: "r3-cp" }) => $network.post("/p/c/login", params, serviceId),
  // 矩阵
  queryCommonStorageByPro: (params) =>
    $network.post("/api/cs/sg/storage/queryCommonStorageByPro", params),
  //调用御城河日志接口
  loginLog: (params, serviceId = { serviceId: "r3-ipcs" }) => $network.post("/ip/v1/yuchenghe/loginLog", params, serviceId),
  // 框架国际化切换接口
  langSwitcher: (params, serviceId = { serviceId: "r3-cp" }) => $network.post("/p/cs/langswitcher", params, serviceId),
  getObject: (params) => $network.post(`/p/cs/getObject?hash=${+new Date()}`, params),
  objectTab: (params) => $network.post(`/p/cs/objectTab?hash=${+new Date()}`, params),
  objectTableItem: (params) => $network.post(`/p/cs/objectTableItem?hash=${+new Date()}`, params),
  selectPromotion: params => $network.post('/api/cs/oc/oms/v1/selectPromotion', params), // 优惠信息
  selectPayment: params => $network.post('/api/cs/oc/oms/v1/selectPayment', params), // 支付信息
  productLog: params => $network.post('/api/cs/md/product/log/QueryList', params), // 组合商品操作日志

  // 自定义的外键关联查询接口
  selSkuLike: (params, serviceId = { serviceId: "r3-ps" }) => $network.post(`/p/cs/md/sku/v1/selSkuLike?hash=${+new Date()}`, params, serviceId),
  selProLike: (params, serviceId = { serviceId: "r3-ps" }) => $network.post(`/p/cs/md/pro/v1/selProLike?hash=${+new Date()}`, params, serviceId),


  // 详情页数据查询接口。共用于：inventoryCenter、orderCenter
  queryPhyWareHouseList: (params) =>
    $network.post("/api/cs/md/queryPhyWareHouseList", params),
  getWarehouseLogisticsTree: (params) =>
    $network.post("/p/cs/getWarehouseLogisticsTree", params),
  getLogisticsRankResultTable: (params) =>
    $network.post("/p/cs/getLogisticsRankResultTable", params),
  getWarehouseLogisticsInfo: (params) =>
    $network.post("/p/cs/getWarehouseLogisticsInfo", params),
  delWarehouseLogistics: (params) =>
    $network.post("/p/cs/delWarehouseLogistics", params),
  fetchActionsInCustomizePage: params => $network.get(`/api/cs/md/v2/fetchActionsInCustomizePage?${qs.stringify(params)}`),
  // fetchActionsInCustomizePage: (params, serviceId) => $network.post("/p/cs/oc/oms/v1/queryActions", params, serviceId || {}),
  manualJdMatchingCheck: (params) =>
    $network.post("/p/cs/manualJdMatchingCheck", params),
  jdReturnStorageSave: (params) =>
    $network.get("/p/cs/jdReturnStorageSave", params),
  manualJdMatchingList: (params) =>
    $network.post("/p/cs/manualJdMatchingList", params),
  screenresult: (params) => $network.post("/api/cs/md/screenresult", params),
  addToFavorite: (params) => $network.post("/p/cs/addToFavorite", params),
  groupTreeload: (params) => $network.post("/api/cs/md/groupTreeload", params),
  removeFromFavorite: (params) =>
    $network.post("/p/cs/removeFromFavorite", params),
  itemDownload: (params) => $network.post("/api/cs/ip/itemDownload", params),
  getUserConfig: (params) => $network.post("/p/cs/getUserConfig", params),
  SgOutNoticePrint: (params) => $network.post("/p/cs/SgOutNoticePrint", params),
  cgroupcolumnquery: (params) =>
    $network.get(`/api/cs/md/cgroupcolumnquery?${qs.stringify(params)}`),
  queryShopPermission: (params) =>
    $network.get("/api/cs/md/queryShopPermission", params),
  screenresultcheck: (params) =>
    $network.post("/api/cs/md/screenresultcheck", params),
  searchButtonsInJdDetail: (params) =>
    $network.post("/p/cs/searchButtonsInJdDetail", params),
  getWarehourseByShopId: (params) =>
    $network.post("/api/cs/md/getWarehourseByShopId", params),
  voidPayableAdjustment: (params) =>
    $network.post("/api/cs/oc/oms/voidPayableAdjustment", params),
  regionBySelect: (params) => $network.post("/api/cs/md/regionBySelect", params),
  exeAction: (params) => $network.post("/p/cs/exeAction", params),
  menuimport: (params) => $network.post("/api/cs/md/menuimport", params),
  queryOcBOrder: (params) =>
    $network.post("/api/cs/oc/oms/v1/queryOcBOrder", params),
  returnOrderquery: (params) =>
    $network.post("/api/cs/oc/oms/v1/returnOrderquery", params),
  returnSkuDb: (params) => $network.post("/p/cs/returnSkuDb", params),
  checkAllStroreStock: (params) =>
    $network.post("/api/cs/oc/oms/v1/checkAllStroreStock", params),
  returnOrder: (params) =>
    $network.post("/api/cs/oc/oms/v1/returnOrder", params),
  chargebackcheck: (params) =>
    $network.post("/api/cs/oc/oms/v1/chargebackcheck", params),
  OcCancelChangingOrRefund: (params) =>
    $network.post("/api/cs/oc/oms/v1/OcCancelChangingOrRefund", params), // 取消退单
  queryLogisticsTrace: params => $network.post('/api/cs/oc/oms/v1/queryLogisticsTrace', params), // 查询物流轨迹
  // updateVirtualLibrary: (params) => $network.post("/p/cs/oc/b/oms/v1/ocbreturnorder/updateOrderVirtual", params),
  updateVirtualLibrary: params => $network.post('/api/cs/oc/oms/v1/updateVirtualLibrary', params), // 虚拟入库
  SelectLog: (params) => $network.post("/p/cs/selectlog", params),
  getOrderList: (params) => $network.post("/p/cs/getOrderList", params),
  queryColorAndSize: (params) => $network.post("/api/cs/md/queryColorAndSize", params),
  extInfoQuery: (params) => $network.post("/api/cs/md/extInfoQuery", params),
  manualJdMatchingConfirmationButton: (params) =>
    $network.post("/p/cs/manualJdMatchingConfirmationButton", params),
  seachJdForced: (params) => $network.post("/p/cs/seachJdForced", params),
  getJdScanIncomingInfo: (params) =>
    $network.post("/p/cs/getJdScanIncomingInfo", params),
  saveJdScanIncoming: (params) =>
    $network.post("/p/cs/saveJdScanIncoming", params),
  groupQueryName: (params) => $network.post("/api/cs/md/groupQueryName", params),
  cuserspro: (params) => $network.post("/p/cs/cuserspro", params),
  cprolikequery: (params) => $network.post("/api/cs/md/cprolikequery", params),
  cgroupsquery: (params) =>
    $network.get(`/api/cs/md/cgroupsquery?${qs.stringify(params)}`),
  getCopyTargetGroups: (params) =>
    $network.get(`/api/cs/md/getCopyTargetGroups?${qs.stringify(params)}`),
  // 导出接口。共用于：financeCenter、inventoryCenter
  exportPayableAdjustment: (params) =>
    $network.post("/api/cs/oc/oms/exportPayableAdjustment", params),
  // 查询接口。共用于：financeCenter、orderCenter
  queryOrderList: (params) =>
    $network.post("/api/cs/oc/oms/v1/queryOrderList", params),

  // tree结构请求接口：
  cpCHrorgTree: (params) => $network.post("/api/cs/md/cpCHrorgTree", params),
  orgTreeload: (params) => $network.post("/api/cs/md/orgTreeload", params),
  // queryClassifyTree: params => $network.post('/p/cs/md/pro/classify/v1/queryClassifyTree', params), // 商品分类-列表-树结构
  // selectTree: params => $network.post('/p/cs/md/v1/region/v1/selectTree', params), // 国家省市区-列表-树结构

  setColPosition: (params) => $network.post("/p/cs/setColPosition", params), //设置表格列的顺序
  queryMenuPermission: params => $network.get(`/api/cs/md/queryMenuPermission?${qs.stringify(params)}`), //功能权限
  batchUnSubmit: (params) => $network.post("/p/cs/batchUnSubmit", params), //取消提交
  getHistory: (params) => $network.post("/api/cs/sg/history/getHistory", params),
  homePageWorkBenchQuery: params => $network.post('/api/cs/rc/HomePageWorkBenchQuery', params), // 首页监控

  objectSave: (params) => $network.post("/p/cs/objectSave", params),
  objectVoid: params => $network.post('/p/cs/objectVoid', params), // 作废
  objectSubmit: params => $network.post('/p/cs/objectSubmit', params),
  objectDelete: (params) => $network.post("/p/cs/objectDelete", params),

  cusSave: (params) => $network.post('/api/cs/sg/save', params), // 保存
  cusVoid: (params) => $network.post('/api/cs/sg/void', params), // 作废
  cusSubmit: params => $network.post('/api/cs/sg/submit', params), // 审核
  cusDelete: params => $network.post('/api/cs/sg/delete', params),


  // 通用接口下载
  /**
   * 经销订单下载 分销商订单下载 /api/cs/ip/orderDownload
   * 分销商品下载 /api/cs/ip/itemDownload
   * 通用商品下载 /api/cs/ip/stdp/item/get
   * 分销退单下载 /api/cs/ip/refundDownload
   * "/api/cs/ip/stdp/order/get
   */

  /**
   *
   * @param {*} url
   * @param {*} params
   * @publicUrlParamsG 有params的 get请求方法
   * @publicUrlParams 有params的 post请求方法
   * @publicNoParams 无params的 post请求方法
   * @getImportDialogHeader 自定义header请求头的post请求方法
   */

  publicUrlParamsGet: (url, params) => $network.get(url, params),
  publicUrlParams: (url, params) => $network.post(url, params),
  publicNoParams: (url) => $network.post(url),
  getImportDialogHeader: (url, params, header) =>
    $network.post(url, params, header),
};
